const CONTENT_EDITOR_SIDEBAR_COLLAPSED_KEY = "contentEditorSidebarCollapsed";

/** Narrow rail width when the content editor sidebar is collapsed (icons + toggle only). */
export const COLLAPSED_CONTENT_EDITOR_SIDEBAR_WIDTH_PX = 56;

export const readContentEditorSidebarCollapsed = () => {
  if (typeof window === "undefined") return false;

  try {
    const raw = sessionStorage.getItem(CONTENT_EDITOR_SIDEBAR_COLLAPSED_KEY);
    if (raw == null || raw === "") return false;
    return raw === "1" || raw === "true";
  } catch (_err) {
    return false;
  }
};

export const writeContentEditorSidebarCollapsed = (collapsed) => {
  if (typeof window === "undefined") return;

  try {
    sessionStorage.setItem(
      CONTENT_EDITOR_SIDEBAR_COLLAPSED_KEY,
      collapsed ? "1" : "0"
    );
  } catch (_err) {
    // Ignore storage errors
  }
};
